import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";
import AuthStore from "stores/AuthStore";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";
import Quiz from "./Quiz";
import QuizDetails from "./Quiz/QuizDetails";
import Question from "./Question";
import QuestionDetails from "./Question/QuestionDetails";
import Section from "./Section";
import SectionDetails from "./Section/SectionDetails";

type Props = RouteComponentProps & {};

@observer
class Questionnaire extends React.Component<Props> {
  componentDidMount() {
    console.log("here start");
  }

  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_QUESTIONNAIRE_QUIZ}
            component={Quiz}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_QUESTIONNAIRE_QUIZ}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_QUESTIONNAIRE_QUIZ_DETAILS}
            component={QuizDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_QUESTIONNAIRE_QUIZ_DETAILS}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_QUESTIONNAIRE_SECTION}
            component={Section}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_QUESTIONNAIRE_SECTION}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_QUESTIONNAIRE_SECTION_DETAILS}
            component={SectionDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_QUESTIONNAIRE_SECTION_DETAILS}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_QUESTIONNAIRE_QUESTION}
            component={Question}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_QUESTIONNAIRE_QUESTION}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_QUESTIONNAIRE_QUESTION_DETAILS}
            component={QuestionDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_QUESTIONNAIRE_QUESTION_DETAILS}
            exact
          />

          <Redirect to={ROUTES.CONTENT_QUESTIONNAIRE_QUIZ} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(Questionnaire);
